import { StoryblokServerComponent, storyblokEditable } from '@storyblok/react/rsc'
import Box from '@audioeye-marketing/ui/src/components/Box'
import getResolvedStoryblokStory from '@/lib/get-resolved-storyblok-story'

const Frame = ({ blok, rels, children }) => {
  const header = getResolvedStoryblokStory({ item: blok?.header, rels })
  const footer = getResolvedStoryblokStory({ item: blok?.footer, rels })

  return (
    <div {...storyblokEditable(blok)}>
      {Boolean(header) && <StoryblokServerComponent blok={header} rels={rels} />}
      {/* ID #content for SkipLink.jsx */}
      <Box component="main" id="content" role="main" tabIndex={-1}>
        {children}
      </Box>
      {Boolean(footer) && <StoryblokServerComponent blok={footer} rels={rels} />}
    </div>
  )
}

export default Frame
